import { useMemo } from "react";

export const Starfield = ({ count = 70 }) => {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map(() => ({
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2 + 1,
        delay: Math.random() * 4,
        dur: 2 + Math.random() * 3.5,
        gold: Math.random() > 0.6,
      })),
    [count]
  );

  return (
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 0 }} aria-hidden>
      {stars.map((s, i) => (
        <span
          key={i}
          className="absolute rounded-full twinkle"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            background: s.gold ? "#FFD54A" : "#ffffff",
            boxShadow: s.gold
              ? "0 0 6px rgba(255,213,74,0.85)"
              : "0 0 5px rgba(255,255,255,0.7)",
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
          }}
        />
      ))}
    </div>
  );
};
